import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  width: PropTypes.string,
  height: PropTypes.string
};

const UserAvatar = ({width = '32', height = '32'}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 32 32">
    <path
      fill="#F5F6F7"
      d="M32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0s16 7.163 16 16z" />
    <mask
      id="mask0_4913_528"
      style={{maskType: 'alpha'}}
      width="32"
      height="32"
      x="0"
      y="0"
      maskUnits="userSpaceOnUse">
      <path
        fill="#F5F6F7"
        fillRule="evenodd"
        d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16z"
        clipRule="evenodd" />
    </mask>
    <g fill="#919BAB" mask="url(#mask0_4913_528)">
      <path
        d="M4 32.157c0-6.56 5.319-11.867 11.867-11.867 6.56 0 11.866 5.319 11.866 11.867"
        opacity="0.6" />
      <path
        fillRule="evenodd"
        d="M4 32.157h10.062c0-4.006-1.986-7.552-5.03-9.702A11.85 11.85 0 004 32.157z"
        clipRule="evenodd"
        opacity="0.4" />
      <path d="M15.867 22.446a6.253 6.253 0 100-12.505 6.253 6.253 0 000 12.505z" />
    </g>
  </svg>
);

UserAvatar.propTypes = propTypes;

export default UserAvatar;
